$('.main-coll-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  dots: false,
  arrows: false,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
      }
    }
  ]
});
$('.main-review-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  dots: false,
  arrows: false,
  lazyLoad: 'ondemand',
  prevArrow: '<div class="slick-prev"><svg class="button-icon left" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
  nextArrow: '<div class="slick-next"><svg class="button-icon right" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      }
    }
  ]
});
$(document).ready(function () {
  $(".set > h2").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".set > h2 i").removeClass("fa-angle-up").addClass("fa-angle-down");
    } else {
      $(".set > h2 i").removeClass("fa-angle-up").addClass("fa-angle-down");
      $(this).find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
      $(".set > h2").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });
});

$(document).ready(function(){
$('.main-img-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  adaptiveHeight: false,
  asNavFor: '.thumb-nav',
  lazyLoad: 'ondemand',
  prevArrow: '<div class="slick-prev"><svg class="button-icon left" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
  nextArrow: '<div class="slick-next"><svg class="button-icon right" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
  
});
// Thumbnail/alternates slider for product page
$('.thumb-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  centerPadding: '0px',
  asNavFor: '.main-img-slider',
  dots: false,
  centerMode: false,
  draggable: true,
  swipeToSlide: true,
  arrows: false,
  vertical: true,
  focusOnSelect: true,
  prevArrow: '<div class="slick-prev"><svg class="button-icon left" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></div>',
  nextArrow: '<div class="slick-next"><svg class="button-icon right" viewBox="0 0 100 100" style="fill: rgb(0, 0, 0);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
});
});

document.addEventListener('DOMContentLoaded', function() {
  const carouselContainer = document.querySelector('.carousel-container');
  const carouselWrapper = carouselContainer.querySelector('.carousel-wrapper');
  const slides = Array.from(carouselWrapper.querySelectorAll('.carousel-slide'));
  let currentIndex = 0;

  carouselContainer.querySelector('.carousel-next').addEventListener('click', function() {
    currentIndex++;
    if (currentIndex >= slides.length - 1) currentIndex = 0; // Loop back to the start
    updateCarousel();
  });

  function updateCarousel() {
    const offset = -(currentIndex * (slides[0].offsetWidth + parseInt(window.getComputedStyle(slides[0]).marginRight)));
    carouselWrapper.style.transform = `translateX(${offset}px)`;
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector('.scrolling-carousel-container');
  
  let isDown = false;
  let startX;
  let scrollLeft;

  carousel.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener('mouseleave', () => {
    isDown = false;
  });

  carousel.addEventListener('mouseup', () => {
    isDown = false;
  });

  carousel.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 3; // 3 is the scroll speed
    carousel.scrollLeft = scrollLeft - walk;
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector('.scrolling-carousel-wrapper');
  const scrollbar = document.querySelector('.scrollbar-container');

  // Update carousel position when custom scrollbar is moved
  scrollbar.addEventListener('scroll', function() {
    const scrollPercentage = scrollbar.scrollLeft / (scrollbar.scrollWidth - scrollbar.clientWidth);
    carousel.scrollLeft = scrollPercentage * (carousel.scrollWidth - carousel.clientWidth);
  });

  // Update custom scrollbar position when carousel is moved
  carousel.addEventListener('scroll', function() {
    const scrollPercentage = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth);
    scrollbar.scrollLeft = scrollPercentage * (scrollbar.scrollWidth - scrollbar.clientWidth);
  });
});


/*modal
document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById('specificationsModal');
  var link = document.querySelector('.rich-text p'); 

  link.addEventListener('click', function(e) {
    e.preventDefault(); 
    modal.classList.add('show'); 
    document.body.classList.add('modal-open'); // Add class to body
  });

  var closeModal = document.querySelector('.close-modal');
  closeModal.addEventListener('click', function(e) {
    e.preventDefault();
    modal.classList.remove('show'); 
    document.body.classList.remove('modal-open'); // Remove class from body
  });
});l*/

